import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Lock from '@material-ui/icons/Lock';
import PlayArrow from '@material-ui/icons/PlayArrow';

import styles from './index.css';


const PlayIcon = (props) => {
  const { hasAccess, playUrl } = props;

  const lockedElement = useMemo(() => {
    if (hasAccess || playUrl) {
      return null;
    }

    return (
      <div className={styles.lock}>
        <Lock className={styles.lockIcon} />
      </div>
    );
  }, [hasAccess, playUrl]);

  return (
    <div className={styles.playButton}>
      <PlayArrow className={styles.playIcon} />
      {lockedElement}
    </div>
  );
};

PlayIcon.propTypes = {
  hasAccess: PropTypes.bool,
  playUrl: PropTypes.string,
};

PlayIcon.defaultProps = {
  hasAccess: false,
  playUrl: undefined,
};

export default observer(PlayIcon);
